import Todo from "./Components/Todo";

const App = () => {
  return ( <Todo /> );
}
 
export default App;